import { createContext, type FC, type PropsWithChildren, use, useState } from "react";
import brandConfig, { updateCurrentBrandConfig } from "@/src/config/brand";
import type { BrandConfig } from "@/src/config/types";

const BrandContext = createContext<BrandConfig>(brandConfig);

type BrandUpdateFn = (partial: Partial<BrandConfig>) => void;
const BrandUpdateContext = createContext<BrandUpdateFn>(() => {});

export const BrandProvider: FC<PropsWithChildren> = ({ children }) => {
  const [config, setConfig] = useState<BrandConfig>(brandConfig);

  const updateConfig = (partial: Partial<BrandConfig>) => {
    setConfig((prev) => {
      const next = { ...prev, ...partial, strings: { ...prev.strings, ...partial.strings } };
      updateCurrentBrandConfig({ strings: next.strings });
      return next;
    });
  };

  return (
    <BrandContext.Provider value={config}>
      <BrandUpdateContext.Provider value={updateConfig}>
        {children}
      </BrandUpdateContext.Provider>
    </BrandContext.Provider>
  );
};

export function useBrand(): BrandConfig {
  return use(BrandContext);
}

export function useBrandUpdate(): BrandUpdateFn {
  return use(BrandUpdateContext);
}

export { default as brandConfig, getCurrentBrandConfig } from "@/src/config/brand";
export type { BrandConfig } from "@/src/config/types";
